/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function retailers(instance) {
	return {
		/**
		 * @param {number} retailerId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (retailerId, config = {}) => {
			return instance.get(`retailers/${retailerId}`, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`retailers${params}`, config)
		},

		/**
		 * @param {number} retailerId
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		edit: (retailerId, body, config = {}) => {
			return instance.put(`retailers/${retailerId}`, body, config)
		},

		/**
		 * @param {number} retailerId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (retailerId, config = {}) => {
			return instance.delete(`retailers/${retailerId}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('retailers', body, config)
		},

		/**
		 * @param {number} receiverId
		 * @param {number} priority
		 */
		priorityCheck: (receiverId, priority) => {
			return instance.get(
				`retailers/priority_check?receiverId=${receiverId}&priority=${priority}`
			)
		},

		/**
		 * @param {number} retailerId
		 * @param {number} marketId
		 * @param {number} countryId
		 * @param {number} receiverId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (
			pageNumber,
			pageSize,
			name,
			marketId,
			countryId,
			receiverId,
			config = {}
		) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const retailerParam = name ? `name=${name}&` : ''
			const marketParam = marketId ? `marketId=${marketId}&` : ''
			const countryParam = countryId ? `countryId=${countryId}&` : ''
			const receiverParam = receiverId ? `receiverId=${receiverId}&` : ''

			return instance.get(
				`retailers/filter?${params}${receiverParam}${marketParam}${countryParam}${retailerParam}`,
				config
			)
		}
	}
}
